// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3e03h","buttons":"styles_buttons__36qLJ"};